import { render, staticRenderFns } from "./add-button.vue?vue&type=template&id=07f91fb0&scoped=true&"
import script from "./add-button.vue?vue&type=script&lang=js&"
export * from "./add-button.vue?vue&type=script&lang=js&"
import style0 from "./add-button.vue?vue&type=style&index=0&id=07f91fb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f91fb0",
  null
  
)

export default component.exports